<template>
    <div class="mini-loan-calculator">
        <h2 v-if="!hasError" class="mini-loan-calculator__headline" id="miniLoanHeadline">{{
            dictionary.miniLoanCalculatorHeadline }}</h2>
        <p v-else class="mini-loan-calculator__headline" style="margin-bottom:0;">{{ dictionary.loanCalculatorErrorMessage }}</p>
        <div v-if="!hasError">
            <div class="mini-loan-calculator__term-slider">
                <Slider id="termSlider" aria-labelledby="miniLoanHeadline" v-model="term" :min="12" :max="120"
                    :step="12" @change="handleTermSliderSlide" />
                <div class="mini-loan-calculator__term-indicator" ref="termIndicator">{{ term }} mdr.</div>
            </div>
            <div class="mini-loan-calculator__result" v-if="loan != null">
                <p class="loan-calculator__correction" v-if="termCorrected && !isInitial">{{
            dictionary.loanCalculatorTermCorrected }}</p>
                <div class="mini-loan-calculator__result-values">
                    <p>{{ dictionary.miniLoanCalculatorMonthlyPayment }} <br /><span
                            class="mini-loan-calculator__result-value">{{
            getLocalNumberString(Math.round(loan.monthlyPaymentAmount)) }} kr.</span></p>
                    <p>{{ dictionary.miniLoanCalculatorDownPayment }} <br /><span
                            class="mini-loan-calculator__result-value">{{
            getLocalNumberString(Math.round(loan.downPayment)) }}
                            kr.</span></p>

                </div>
            </div>
            <div class="mini-loan-calculator__cta-wrap">
                <a class="mini-loan-calculator__cta" href="#vehicleFinance">{{ dictionary.miniLoanCalculatorCta }}</a>
            </div>
        </div>
    </div>
</template>
<script>
import VueHelpers from './vueHelpers';
import Slider from 'primevue/slider';
var termSlideTimer;
export default {
    name: "miniLoanCalculator",
    components: {
        Slider
    },
    data() {
        return {
            dictionary: [],
            vehicle: null,
            isLoading: false,
            isInitial: true,
            termCorrected: false,
            term: 120,
            loan: null,
            hasError: false
        };
    },
    created() {
        const vm = this;
        vm.vehicle = JSON.parse(vm.$parent.vehicle);
        vm.culture = document.querySelector("html").getAttribute("lang");

        fetch('/umbraco/api/resourcesApi/GetMiniLoanCalculatorDictionary').then((response) => response.json())
            .then((data) => {
                vm.dictionary = data;
            })
            .catch((error) => {
                console.log(error);
            });

        vm.recalculateLoan(false);
    },
    mounted() {
        this.positionTermIndication();
    },
    methods: {
        getLocalNumberString(number) {
            return VueHelpers.getLocalNumberString(number);
        },
        positionTermIndication: function () {
            const sliderHandle = this.$el.querySelector('.p-slider-handle');
            sliderHandle.appendChild(this.$refs.termIndicator)
        },
        handleTermSliderSlide: function () {
            var vm = this;
            clearTimeout(termSlideTimer)
            termSlideTimer = setTimeout(() => {
                vm.recalculateLoan(true);
            }, 500);
            vm.positionTermIndication();
        },
        recalculateLoan: function (showSpinner = false) {
            const vm = this;
            vm.toggleSpinner(showSpinner);

            vm.isInitial = vm.loan == null;
            vm.loan = null;
            vm.downPaymentCorrected = false;
            vm.termCorrected = false;

            const loanRequestModel = {
                vehicleVin: vm.vehicle.Vin,
                vehiclePrice: vm.vehicle.Price,
                vehicleRegistrationDate: vm.vehicle.RegistrationDate,
                vehicleBrand: vm.vehicle.BrandAlias.replace(' ', ''),
                vehicleFuelType: vm.vehicle.SystemFuelType,
                term: vm.term,
                interestType: 'Variable'
            };

            fetch('/umbraco/api/financialApi/getLoanCalculation?' + new URLSearchParams(loanRequestModel))
            .then((response) => {
                if (response.status == 400) {
                    const error = new Error("");
                    error.status = response.status;
                    throw error;
                }
                return response;
            }).then(response => response.json())
                .then((data) => {
                    vm.loan = data;

                    if (data.termCorrected) {
                        vm.term = data.term;
                        vm.termCorrected = true;
                    }
                    vm.toggleSpinner(false);

                })
                .catch((error) => {
                    vm.toggleSpinner(false);
                    vm.hasError = true;
                    console.log(error);
                });

        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;

            const bodyElement = document.querySelector("body");
            if (isLoading) {
                bodyElement.classList.add("is-loading");
            } else {
                bodyElement.classList.remove("is-loading");
            }
        }
    }
};
</script>
